module.exports = __webpack_public_path__ + "img/share_chapter_kongtian@2x.f38542eb.png";